import classNames from 'classnames';
import React, { JSX } from 'react';
import { styled } from '@mui/material/styles';

type IBreakLineProps = JSX.IntrinsicElements['div'];

export const BreakLine = styled(
	React.forwardRef<HTMLDivElement, IBreakLineProps>(
		({ className, children, ...props }, ref) => {
			return (
				<div
					className={classNames('breakline', className)}
					{...props}
					ref={ref}
				>
					{children ? (
						<>
							<div className="breakline__left" />
							<div className="breakline__center">{children}</div>
							<div className="breakline__right" />
						</>
					) : (
						<div className="breakline__full" />
					)}
				</div>
			);
		},
	),
	{
		label: 'BreakLine',
		target: 'BreakLine-root',
	},
)({
	display: 'grid',
	gridTemplateColumns: 'minmax(2em, 1fr) auto minmax(2em, 1fr)',
	gridTemplateAreas: '"left center right"',
	alignItems: 'center',
	flexWrap: 'nowrap',
	color: 'var(--breakline_color)',
	fontFamily: 'Roboto, sans-serif',
	fontSize: '1em',
	fontWeight: 'bold',
	'& .breakline__full, & .breakline__left, & .breakline__right': {
		height: '1px',
		justifySelf: 'stretch',
		background: 'var(--breakline_color)',
	},
	'& .breakline__left': {
		gridArea: 'left',
	},
	'& .breakline__right': {
		gridArea: 'right',
	},
	'& .breakline__center': {
		gridArea: 'center',
		margin: '0 0.5em',
	},
	'& .breakline__full': {
		gridArea: 'left / left / right / right',
	},
	'&.breakline--primary': {
		'--breakline_color': 'var(--theme--primary)',
	},
});
